// maintain alphabetical order
// the fastest way to sort:
// 1. make sure each key value pair takes up only one line. no line breaks.
// 2. highlight all keys and values
// 3a. right click - command palette - search for 'Sort Lines Ascending'
// 3b. cmd + shift + p - search for 'Sort Lines Ascending'
// 3c. protip: make a keyboard shortcut for this.
export const enCommon = {
  ABFilters: 'A/B Filters',
  ABFiltersWithAsterisk: 'A/B Filters *',
  ABTest: 'A/B Test',
  ABTestingTraffic: 'A/B Testing Traffic',
  Accept: 'Accept',
  Account: 'Account',
  Action: 'Action',
  Actions: 'Actions',
  Activate: 'Activate',
  ActivateItem: 'Activate {{item}}',
  Active: 'Active',
  ActiveColumn: 'Active Column',
  ActiveColumns: 'Active Columns',
  ActiveFields: 'Active Fields',
  AdaptiveFloors: 'Adaptive Floors',
  AdBreak: 'Ad Break',
  AdBreakDetails: 'Ad Break Details',
  AdBreakID: 'Ad Break ID',
  AdBreaks: 'Ad Breaks',
  AdBreakSchedule: 'Ad Break Schedule',
  AdBreakScheduleHelperText: 'Configure ad breaks with custom cue points for your content. Each ad break can have unique timing, duration, and placement settings.',
  AdBreakSchedules: 'Ad Break Schedules',
  AdBreaksData: 'Ad Breaks Data',
  AdBreakTooltipBreakdown: 'Breakdown of information for each ad break',
  AdBreakWithAsterisk: 'Ad Break *',
  AdCode: 'Ad Code',
  AddEditItem: 'Add/Edit {{item}}',
  AddFilter: '+ Add Filter',
  AddItem: 'Add {{item}}',
  AdditionalBuyer: 'Additional Buyer',
  AddMetric: '+ Add Metric',
  AddNewExtensionKeyValueParameter: 'Add New Extension Key-Value Parameter',
  AddNewKeyValueParameter: 'Add New Key-Value Parameter',
  AddToGroup: 'Add to Group',
  AdDurationSeconds: 'Ad Duration (sec)',
  AddValueOnlyIfObjEmptyInBidRequest: 'Add value only if obj. empty in bid request',
  AdInsertion: 'Ad Insertion',
  Adomain: 'Adomain',
  Adomains: 'Adomains',
  AdQualityToolsConfirmation: 'If the toggle is off or the features are unselected, this action will turn off the feature and remove its configuration.',
  AdserverCampaigns: 'Adserver Campaigns',
  AdTagURI: 'Ad Tag URI',
  AdUnit: 'Ad Unit',
  AdvancedOptionalSettings: 'Advanced & Optional Settings',
  Advertiser: 'Advertiser',
  Advertisers: 'Advertisers',
  Africa: 'Africa',
  All: 'All',
  AllDirect: 'All Direct',
  AllHouse: 'All House',
  AllItems: 'All {{item}}',
  AllItemsSelected: 'All {{item}} Selected',
  AllLineItems: 'All Line Items',
  Allow: 'Allow',
  AllowAll: 'Allow All',
  Allowed: 'Allowed',
  AllowedItem: 'Allowed {{item}}',
  AllowPublisherToAccessAndManageFraudDetectionWithAsterisk: 'Allow Publisher to Access and Manage Fraud Detection *',
  AllTables: 'All Tables',
  AllUsers: 'All Users',
  AMPM: 'AM/PM',
  Analytics: 'Analytics',
  And: 'And',
  AnonymizeDeviceID: 'Anonymize Device ID',
  AnonymizeIP: 'Anonymize IP',
  AnyPod: 'Any Pod',
  APAC: 'APAC',
  App: 'App',
  AppAndSite: 'App and Site',
  AppBundle: 'App Bundle',
  AppBundleID: 'App Bundle ID',
  AppBundleIDAllowed: 'App Bundle ID Allowed',
  AppBundleIDDescription: 'App Bundle ID to bid on, comma separated.',
  AppBundleIDs: 'App Bundle IDs',
  AppBundleIDsAndSitePages: 'App Bundle IDs & Site Pages',
  AppBundleOverride: 'App Bundle Override',
  AppBundleOverrideIfEmpty: 'App Bundle Override If Empty',
  AppDomain: 'App Domain',
  AppDomainOverride: 'App Domain Override',
  AppDomainOverrideIfEmpty: 'App Domain Override If Empty',
  AppDomainOverrideWithAsterisk: 'App Domain Override *',
  AppID: 'App ID',
  AppIDOverride: 'App ID Override',
  AppIDOverrideIfEmpty: 'App ID Override If Empty',
  AppIDWebExchangeIDOTT: 'app_id (web) exchange_id (OTT)',
  Apply: 'Apply',
  ApplyBidFloorToAllBuyers: 'Apply bid floor to all buyers',
  ApplySelectedItem: 'Apply Selected {{item}}',
  AppName: 'App Name',
  AppNameOverride: 'App Name Override',
  AppNameOverrideIfEmpty: 'App Name Override If Empty',
  AppSite: 'App Site',
  AppStoreURL: 'App Store URL',
  AppStoreURLWithAsterisk: 'App Store URL *',
  AppWithAsterisk: 'App *',
  Ascending: 'Ascending',
  Assistant: 'Assistant',
  AssociatedInventoryRules: 'Associated Inventory Rules',
  At: 'At',
  AuctionBuyer: 'Auction Buyer',
  AuctionBuyers: 'Auction Buyers',
  AuctionFlow: 'Auction Flow',
  AuctionInsights: 'Auction Insights',
  AuctionParticipationPercentage: 'Auction Participation Percentage',
  AuctionType: 'Auction Type',
  Audience: 'Audience',
  AudienceSegments: 'Audience Segments',
  AutomaticallyBlocksFraudAcrossAllOfYourInventory: 'Automatically blocks fraud across all of your inventory',
  AutoRefresh: 'Auto-Refresh',
  AvgControlBidFloor: 'Avg Control Floor',
  AvgCPML24H: 'Avg. CPM (L24H)',
  AvgCPML7D: 'Avg. CPM (L7D)',
  AvgSmartBidFloor: 'Avg Smart Floor',
  AWSS3: 'AWS S3',
  BackToItemList: '< Back to {{item}} List',
  BaseFloor: 'Base Floor',
  Beta: 'Beta',
  BidAdjustment: 'Bid Adjustment',
  BidAdjValue: 'Bid Adj. Value',
  Bidder: 'Bidder',
  BidderGroup: 'Bidder Group',
  BidderGroupLabels: 'Bidder Group Labels',
  BidderGroups: 'Bidder Groups',
  BidderID: 'Bidder ID',
  BidderIDs: 'Bidder IDs',
  BidderLabel: 'Bidder Label',
  BidderLabels: 'Bidder Labels',
  BidderLevelExtendedID: 'Bidder Level Extended ID',
  Bidders: 'Bidders',
  BidderSettings: 'Bidder Settings',
  BiddersToSitesAssociation: 'Bidders to Sites Association',
  BidderSubTier: 'Bidder SubTier',
  BidderTier: 'Bidder Tier',
  BidderTiers: 'Bidder Tiers',
  BidderTimeout: 'Bidder Timeout',
  BidderType: 'Bidder Type',
  BidderTypes: 'Bidder Types',
  BidErrorCodeBadInputError: 'Bad Input Error',
  BidErrorCodeBadServerResponseError: 'Bad Server Response Error',
  BidErrorCodeBidAuctionFailed: 'Bid Auction Failed',
  BidErrorCodeBidConnectionError: 'Bid Connection Error',
  BidErrorCodeBidConnectionResetByPeer: 'Bid Connection Reset By Peer',
  BidErrorCodeBidderNotSharedInventory: 'Bidder Inventory Type Not Shared',
  BidErrorCodeBidMissingVastMeta: 'Bid Missing Vast Meta',
  BidErrorCodeBidPriceBelowFloor: 'Bid Price Below Floor',
  BidErrorCodeBidPriceMissing: 'Bid Price Missing',
  BidErrorCodeBidPriceTooHigh: 'Bid Price Too High',
  BidErrorCodeBidRejectedAboveMaxAdDuration: 'Bid Rejected Above Max Ad Duration',
  BidErrorCodeBidRejectedAboveSharedPodDuration: 'Bid Rejected Shared Pod Duration',
  BidErrorCodeBidRejectedAdomainMissing: 'Bid Rejected Adomain Missing',
  BidErrorCodeBidRejectedAdvertiserBlocklist: 'Bid Rejected Advertiser Blocklist',
  BidErrorCodeBidRejectedAdvertiserRuleCompetitiveSeparationOther: 'Bid Rejected Advertiser Rule CompSep Other',
  BidErrorCodeBidRejectedAdvertiserRuleCompetitiveSeparationSelf: 'Bid Rejected Advertiser Rule CompSep Self',
  BidErrorCodeBidRejectedAdvertiserRuleDoNotAir: 'Bid Rejected Advertiser Rule DNA',
  BidErrorCodeBidRejectedAllHouseAds: 'Bid Rejected All House Ads',
  BidErrorCodeBidRejectedBelowFloor: 'Bid Rejected Below Floor',
  BidErrorCodeBidRejectedBelowMinAdDuration: 'Bid Rejected Below Min Ad Duration',
  BidErrorCodeBidRejectedBlockedByAdvertiser: 'Bid Rejected Blocked By Advertiser',
  BidErrorCodeBidRejectedBrandSafetyRuleBlock: 'Bid Rejected Brand Safety Rule Block',
  BidErrorCodeBidRejectedCacheConnection: 'Cache Connection',
  BidErrorCodeBidRejectedCacheID: 'Bid Rejected Cache ID',
  BidErrorCodeBidRejectedCacheStore: 'Cache Store',
  BidErrorCodeBidRejectedCacheXMLEncode: 'Cache XML Encode',
  BidErrorCodeBidRejectedCategoryExclusivity: 'Bid Rejected Category Exclusivity',
  BidErrorCodeBidRejectedCreativeBlock404NotFound: 'Creative Block 404 Not Found',
  BidErrorCodeBidRejectedCreativeBlockMismatchDuration: 'Creative Block Mismatch Duration',
  BidErrorCodeBidRejectedCreativeBlockUnknown: 'Creative Block Unknown',
  BidErrorCodeBidRejectedCreativeIDBlock: 'Bid Rejected Creative ID Blocked',
  BidErrorCodeBidRejectedCreativeQualityAssurance: 'Bid Rejected Creative Quality Assurance',
  BidErrorCodeBidRejectedCreativeValidationRejected: 'Creative Validation Rejected',
  BidErrorCodeBidRejectedDupAdID: 'Bid Rejected Dup AdID',
  BidErrorCodeBidRejectedDupAdomain: 'Bid Rejected Dup Adomain',
  BidErrorCodeBidRejectedDupAdomainClickThrough: 'Bid Rejected Dup Adomain (Clickthrough)',
  BidErrorCodeBidRejectedDupAdomainElea: 'Bid Rejected Dup Adomain (Elea)',
  BidErrorCodeBidRejectedDupAPSKey: 'Bid Rejected Duplicate APS Key',
  BidErrorCodeBidRejectedDupBidCatExclusion: 'Bid Rejected Duplicate Bid Cat Exclusion',
  BidErrorCodeBidRejectedDupCampaignID: 'Bid Rejected Duplicate Campaign ID',
  BidErrorCodeBidRejectedDupCategory: 'Bid Rejected Dup Category',
  BidErrorCodeBidRejectedDupCategoryElea: 'Bid Rejected Dup Category (Elea)',
  BidErrorCodeBidRejectedDupCreativeID: 'Bid Rejected Dup CreativeID',
  BidErrorCodeBidRejectedDupMediafileURL: 'Bid Rejected Dup Mediafile URL',
  BidErrorCodeBidRejectedDupMediafileURLNormal: 'Bid Rejected Dup Mediafile URL Normal',
  BidErrorCodeBidRejectedDupPhiloAudioIdent: 'Bid Rejected Dup Philo Audio Ident',
  BidErrorCodeBidRejectedDuration: 'Bid Rejected Duration',
  BidErrorCodeBidRejectedEventTrackerBlocklist: 'Bid Rejected Event Tracker Block list',
  BidErrorCodeBidRejectedIABCatBlocklist: 'Bid Rejected IAB Cat Blocklist',
  BidErrorCodeBidRejectedLanguageBlocklist: 'Bid Rejected Language Blocklist',
  BidErrorCodeBidRejectedMediafileBlocklist: 'Bid Rejected Mediafile Block List',
  BidErrorCodeBidRejectedMinPodSizeNotMeet: 'Bid Rejected Min Pod Size',
  BidErrorCodeBidRejectedNonsecureVAST: 'Bid Rejected Nonsecure VAST',
  BidErrorCodeBidRejectedNotFirstSlotInPod: 'Bid Not First Slot In Pod',
  BidErrorCodeBidRejectedOverCampaignFrequencyCap: 'Over Campaign Frequency Cap',
  BidErrorCodeBidRejectedOverOrderFrequencyCap: 'Over Order Frequency Cap',
  BidErrorCodeBidRejectedPlatformConnectionBidderSlotTargetingMismatch: 'Bid Rejected Platform Connection Bidder Slot Targeting Mismatch',
  BidErrorCodeBidRejectedPodFloor: 'Bid Rejected Pod Floor',
  BidErrorCodeBidRejectedPrice: 'Bid Rejected Price',
  BidErrorCodeBidRejectedPriceAboveErrorThreshold: 'Bid Rejected Price Above Error Threshold',
  BidErrorCodeBidRejectedPrivateAuctionDealIDMismatch: 'Bid Rejected Private Auction Deal ID Mismatch',
  BidErrorCodeBidRejectedSlotTargetingMismatch: 'Bid Rejected Slot Targeting Mismatch',
  BidErrorCodeBidRejectedTier: 'Bid Rejected Tier',
  BidErrorCodeBidRejectedTooManyBidCatExclusion: 'Bid Rejected Too Many Bid Cat Exclusions',
  BidErrorCodeBidRejectedUnknown: 'Bid Rejected Unknown',
  BidErrorCodeBidSiteLoopError: 'Site Loop Error',
  BidErrorCodeCachePutCacheMiss: 'Cache Put Cache Miss',
  BidErrorCodeCombineCreativeError: 'Combine Creative Error',
  BidErrorCodeConnectionError: 'Connection Error',
  BidErrorCodeEmptyResponseError: 'Empty Response Error',
  BidErrorCodeEmptyVastError: 'Empty Vast Error',
  BidErrorCodeEOFError: 'Bid Rejected EOF Error',
  BidErrorCodeFailedToParseResponse: 'Failed To Parse Response',
  BidErrorCodeFailedToRequestBidsError: 'Failed To Request Bids Error',
  BidErrorCodeGzipReadError: 'GZip Read Error',
  BidErrorCodeInvalidMediafileDeliveryType: 'Invalid Mediafile Delivery Type',
  BidErrorCodeInvalidRequestURL: 'Invalid Bid Request URL',
  BidErrorCodeMacroReplacementErrorCode: 'Macro Replacement Error',
  BidErrorCodeMaxUnwrapError: 'Bid Rejected Over Max Unwrap',
  BidErrorCodeNoContent204Error: 'No Content 204 Error',
  BidErrorCodeNoFillError: 'No Fill Error',
  BidErrorCodeNoMediafileSatisfyEndpointMaxBitrate: 'No Mediafile Satisfy Endpoint Max Bitrate',
  BidErrorCodeNoMediafileSatisfyEndpointMinBitrate: 'No Mediafile Satisfy Endpoint Min Bitrate',
  BidErrorCodeNoMediafileSatisfySiteMaxBitrate: 'No Mediafile Satisfy Max Bitrate',
  BidErrorCodeNoMediafileSatisfySiteMinBitrate: 'No Mediafile Satisfy Site Min Bitrate',
  BidErrorCodeOtherUnwrapError: 'Other Unwrap Error',
  BidErrorCodePanic: 'Panic',
  BidErrorCodePrebidError: 'Prebid Error',
  BidErrorCodeRateLimitBlocked: 'Rate Limit Blocked',
  BidErrorCodeResponseEOFError: 'Response End Of File Error',
  BidErrorCodeTimeoutError: 'Timeout Error',
  BidErrorCodeUndefined: 'Undefined (Deprecated)',
  BidErrorCodeUnknownError: 'Unknown Error',
  BidErrorCodeUnwrapEOFError: 'Unwrap End Of File Error',
  BidErrorCodeUnwrapParseError: 'Unwrap Parse Error',
  BidErrorCodeUnwrapTimeoutError: 'Unwrap Timeout Error',
  BidErrorCodeVastValidateError: 'Vast Validate Error',
  BidErrorCodeXMLSyntaxError: 'Bid Rejected XML Syntax Error',
  BidErrors: 'Bid Errors',
  BidErrorsBreakdown: 'Bid Errors Breakdown',
  BidFloor: 'Bid Floor',
  BidFloorAdjustment: 'Bid Floor Adjustment',
  BidFloorCurrency: 'Bid Floor Currency',
  BidLost: 'Bid Lost',
  BidRejected: 'Bid Rejected',
  BidRequest: 'Bid Request',
  BidRequestRewrite: 'Bid Request Rewrite',
  BidRequests: 'Bid Requests',
  BidResponseErrors: 'Bid Response Errors',
  BidResponses: 'Bid Responses',
  BidTimeouts: 'Bid Timeouts',
  BidWon: 'Bid Won',
  Block: 'Block',
  Blocked: 'Blocked',
  BrandSafety: 'Brand Safety',
  BrandSafetyRule: 'Brand Safety Rule',
  BrandSafetyRules: 'Brand Safety Rules',
  BrandsDashboard: 'Brands Dashboard',
  Breakdown: 'Breakdown',
  Budget: 'Budget',
  BulkUpdate: 'Bulk Update',
  BulkUpload: 'Bulk Upload',
  BulkUploaderWiki: 'Bulk Uploader Wiki',
  Buyer: 'Buyer',
  BuyerAdomain: 'Buyer Adomain',
  BuyerDSP: 'Buyer DSP',
  BuyerSeatID: 'Buyer Seat ID',
  BuyingPartner: 'Buying Partner',
  BuyType: 'Buy Type',
  ByPod: 'By Pod',
  ByPodDuration: 'By Pod Duration',
  CampaignAuctionInsights: 'Campaign Auction Insights',
  CampaignNoFillErrorCodeAdserverOrderNotFound: 'Adserver Order Not Found In Cache',
  CampaignNoFillErrorCodeCreativeSelectionError: 'Creative Selection Error',
  CampaignNoFillErrorCodeEmaPacing: 'EMA Pacing Diceroll Rejection',
  CampaignNoFillErrorCodeEMAPacingDataNotFound: 'EMA Pacing Data Not Found',
  CampaignNoFillErrorCodeEmptyVast: 'Empty vast',
  CampaignNoFillErrorCodeEmptyVastMediafile: 'Empty Vast Mediafile',
  CampaignNoFillErrorCodeFrequencyCap: 'Frequency Cap',
  CampaignNoFillErrorCodeLowPacing: 'Low Pacing',
  CampaignNoFillErrorCodeOrderFrequencyCap: 'Order Frequency Cap',
  CampaignNoFillErrorCodePacing: 'Pacing',
  CampaignNoFillErrorCodeSiteLoopError: 'Site Loop Error',
  CampaignNoFillErrorCodeUndefined: 'Undefined',
  CampaignNoFillErrorCodeVastTimeout: 'Vast Timeout',
  CampaignNoFillErrorCodeZeroDuration: 'Mediafile Has Zero Duration',
  Campaigns: 'Campaigns',
  CampaignStatus: 'Campaign Status',
  CampaignStatusTooltipCompleted: 'Campaign ended.',
  CampaignStatusTooltipDelivering: 'Campaign is delivering.',
  CampaignStatusTooltipDraft: 'Campaign has no creatives.',
  CampaignStatusTooltipGoalMet: 'Delivery goal met. Campaign no longer serving.',
  CampaignStatusTooltipInactive: 'Campaign tag is inactive.',
  CampaignStatusTooltipMediafileError: 'Media File uploaded is corrupted or fails to meet banner requirements. Please fix it to enable campaign delivery.',
  CampaignStatusTooltipNotStartedYet: 'Campaign start date is in the future.',
  CampaignStatusTooltipReady: 'Campaign has started but the first impressions are still pending. As soon as a first impression is recorded campaign status will update to "Delivering".',
  CampaignStatusTooltipUntargeted: 'Campaign isn\'t targeted to any bidder. Go to bidders to complete setup.',
  CanBeCommaSeparated: 'can be comma separated',
  Cancel: 'Cancel',
  Category: 'Category',
  CCPA: 'CCPA',
  ChangeLogs: 'Change Logs',
  Channel: 'Channel',
  ChannelFloors: 'Channel Floors',
  ChannelGroup: 'Channel Group',
  ChannelGroups: 'Channel Groups',
  ChannelLabel: 'Channel Label',
  ChannelLabels: 'Channel Labels',
  ChannelList: 'Channel List',
  ChannelLists: 'Channel Lists',
  Channels: 'Channels',
  Chart: 'Chart',
  ChartDisplay: 'Chart Display',
  ChooseHowToCreateNewItem: `Choose how you’d like to create a new {{item}}`,
  ChooseWhichItemToUseAsTemplate: `Choose which {{item}} you’d like to use as a template`,
  Cities: 'Cities',
  City: 'City',
  Clear: 'Clear',
  ClearAll: 'Clear All',
  ClearBitrate: 'Clear Bitrate',
  ClearDates: 'Clear Dates',
  ClearDefaultMaxMinBitrate: 'Clear default max/min bitrate.',
  ClearItem: 'Clear {{item}}',
  ClearMaxMinBitrate: 'Clear max/min bitrate.',
  ClickSoundOn: 'Click sound on',
  Clone: 'Clone',
  Cloned: 'Cloned',
  CloneExistingItem: 'Clone an existing {{item}}',
  CloneItem: 'Clone {{item}}',
  Close: 'Close',
  CollapseAll: 'Collapse All',
  CombineVMAPRequests: 'Combine VMAP Requests',
  CombineVMAPRequestsWithAsterisk: 'Combine VMAP Requests *',
  CommaSeparated: 'Comma Separated',
  CommonCountryGroups: 'Common Country Groups',
  Company: 'Company',
  Compare: 'Compare',
  ComparedTo: 'Compared To',
  Completed: 'Completed',
  Configuration: 'Configuration',
  Configurations: 'Configurations',
  ConfigurePerBidderWithColon: 'Configure Per Bidder:',
  ConfigureTargetingParametersForThisDeal: 'Configure targeting parameters for this deal',
  Confirm: 'Confirm',
  ConfirmActivatingItemWithName: 'Are you sure you want to activate {{item}}: {{name}}?',
  ConfirmAndSave: 'Confirm and Save',
  ConfirmBulkEditItem: 'Confirm Bulk Edit {{items}}',
  ConfirmDeactivatingItemWithName: 'Are you sure you want to deactivate {{item}: {{name}}}?',
  ConfirmDeletingItemWithName: 'Are you sure you want to delete this {{item}}: "{{name}}"?',
  ConfirmSaveItem: 'Confirm Save {{item}}',
  ConnectionErrors: 'Connection Errors',
  ConsoleErrorMsgMissingEndDate: 'End date is required.',
  ConsoleErrorMsgMissingStartDate: 'Start date is required.',
  ConsoleErrorMsgSiteBidderCombinationsExceedLimit: 'The Site-Bidder combinations have exceeded the maximum limit of 5000. Please adjust your filters.',
  ConsoleErrorMsgUnexpectedError: 'An unexpected error occurred. Please try again.',
  Contains: 'Contains',
  Content: 'Content',
  ContentCategory: 'Content Category',
  ContentChannel: 'Content Channel',
  ContentContext: 'Content Context',
  ContentData: 'Content Data',
  ContentDistributionID: 'Content Distribution ID',
  ContentDistributionName: 'Content Distribution Name',
  ContentDistributor: 'Content Distributor',
  ContentDistributorName: 'Content Distributor Name',
  ContentDistributorNameOverride: 'Content Distributor Name Override',
  ContentDistributorNameOverrideIfEmpty: 'Content Distributor Name Override If Empty',
  ContentEpisode: 'Content Episode',
  ContentGenre: 'Content Genre',
  ContentID: 'Content ID',
  ContentItem: 'Content {{item}}',
  ContentItemAllowed: 'Content {{item}} Allowed',
  ContentItemOverride: 'Content {{item}} Override',
  ContentKeywords: 'Content Keywords',
  ContentLanguage: 'Content Language',
  ContentLength: 'Content Length',
  ContentMetadata: 'Content Metadata',
  ContentMetadataSettings: 'Content Metadata Settings',
  ContentMetadataSettingsHelperText: 'Define content parameters for categorization. Saving this rule automatically creates a new content metadata subrule.',
  ContentNetwork: 'Content Network',
  ContentParameter: 'Content Parameter',
  ContentProdQuality: 'Content Prod Quality',
  ContentProducer: 'Content Producer',
  ContentProducerID: 'Content Producer ID',
  ContentRating: 'Content Rating',
  ContentSeason: 'Content Season',
  ContentSeries: 'Content Series',
  ContentTaxonomy: 'Content Taxonomy',
  ContentTitle: 'Content Title',
  ContentURL: 'Content URL',
  ContentWithAsterisk: 'Content *',
  Contextual: 'Contextual',
  ContextualSegment: 'Contextual Segment',
  ContextualSegmentIDs: 'Contextual Segment IDs',
  ContextualSegments: 'Contextual Segments',
  ControlWithParentheses: '(control)',
  COPPA: 'COPPA',
  Copy: 'Copy',
  Countries: 'Countries',
  CountriesTargeted: 'Countries Targeted',
  Country: 'Country',
  CountryGroup: 'Country Group',
  CountryGroups: 'Country Groups',
  CPMOrCPMS: 'CPM or CPM/S',
  CreateBidder: 'Create Bidder',
  CreateBidderGroup: 'Create Bidder Group',
  CreatedBy: 'Created By',
  CreatedDate: 'Created Date',
  CreateItem: 'Create {{item}}',
  CreateNewItem: 'Create New {{item}}',
  CreatingNewGroup: 'Creating New Group',
  Creative: 'Creative',
  CreativeID: 'Creative ID',
  CreativeLibrary: 'Creative Library',
  CreativeReview: 'Creative Review',
  CreativeReviews: 'Creative Reviews',
  Creatives: 'Creatives',
  CreativeURL: 'Creative URL',
  CreativeURLs: 'Creative URLs',
  CreativeValidation: 'Creative Validation',
  CreativeValidations: 'Creative Validations',
  CSVLastUpdated: 'CSV Last Updated',
  CSVSummary: 'CSV Summary',
  CuePoint: 'Cue Point',
  CuePointType: 'Cue Point Type',
  CuePointTypes: 'Cue Point Types',
  CuePointValue: 'Cue Point Value',
  Currency: 'Currency',
  CurrencyExchangeRate: 'Currency Exchange Rate',
  CurrentEditsWillImpactTheFollowing: 'Current edits will impact the following',
  CurrentTest: 'Current Test',
  CurrentUser: 'Current User',
  Custom: 'Custom',
  Custom10: 'Custom 10',
  Custom11: 'Custom 11',
  Custom12: 'Custom 12',
  Custom13: 'Custom 13',
  Custom14: 'Custom 14',
  Custom15: 'Custom 15',
  Custom16: 'Custom 16',
  Custom17: 'Custom 17',
  Custom18: 'Custom 18',
  Custom4: 'Custom 4',
  Custom5: 'Custom 5',
  Custom6: 'Custom 6',
  Custom7: 'Custom 7',
  Custom8: 'Custom 8',
  Custom9: 'Custom 9',
  CustomData: 'Custom Data',
  CustomDataSettings: 'Custom Data Settings',
  CustomDataSettingsHelperText: 'Add custom key-value pairs for extended metadata. Saving this rule automatically creates a new custom data subrule.',
  CustomDate: 'Custom Date',
  CustomDateTooltipText: 'Select a date range to view historical data.',
  CustomItemInclusion: 'Custom {{item}} Inclusion',
  CustomItemName: 'Custom {{item}} Name',
  CustomizeData: 'Customize Data',
  CustomMetric: 'Custom Metric',
  CustomParameter: 'Custom Parameter',
  CustomsData: 'Customs Data',
  CustomTargeting: 'Custom Targeting',
  Daily: 'Daily',
  DailyImpressionLimit: 'Daily Impression Limit',
  DailyRequestCap: 'Daily Request Cap',
  DailyRequestLimit: 'Daily Request Limit',
  Dashboard: 'Dashboard',
  Dashboards: 'Dashboards',
  Data: 'Data',
  DataID: 'Data ID',
  Dataset: 'Dataset',
  DataSharing: 'Data Sharing',
  DataWillBeAvailableOnceTheCampaignBegins: 'Data will be available once the campaign begins.',
  DateRange: 'Date Range',
  DateTimes: 'Date Times',
  Dayparting: 'Dayparting',
  DaypartingActive: 'DaypartingActive',
  DaypartingExcludeDescription: '{{item}} will NOT deliver during the selected hours and days.',
  DaypartingIncludeDescription: '{{item}} will deliver during the selected hours and days.',
  DaypartingIncludeExclude: 'Dayparting Include/Exclude',
  DaypartingIsAllowed: 'DaypartingIsAllowed',
  Daypartings: 'Daypartings',
  DaypartingTimezoneBidder: 'Bidder Timezone',
  DaypartingTimezoneBidderDescription: "Dayparting will adhere to the viewer's timezone using their device location.",
  DaypartingTimezoneBrandSafetyRule: 'Rule Timezone',
  DaypartingTimezoneBrandSafetyRuleDescription: 'Dayparting will adhere to the timezone set for the brand safety rule.',
  DaypartingTimezoneDeviceLocation: 'Viewer Timezone',
  DaypartingTimezoneDeviceLocationDescription: "Dayparting will adhere to the viewer's timezone using their device location.",
  DaypartingTimezoneLineItem: 'Line Item Timezone',
  DaypartingTimezonePublisher: 'Publisher Timezone',
  DaypartingTimezonePublisherDescription: 'Dayparting will adhere to the timezone set for the publisher.',
  DaypartingTooltip: 'Use dayparting to set days of the week and hours when you want this {{item}} to run. Adding multiple options will provide extra granularity.',
  Deactivate: 'Deactivate',
  DeactivateItem: 'Deactivate {{item}}',
  Deal: 'Deal',
  DealID: 'Deal ID',
  DealIDPassthrough: 'Deal ID Passthrough',
  DealIDPassthroughFromEndpoint: 'Deal ID passthrough from Endpoint',
  DealIDs: 'Deal IDs',
  DealName: 'Deal Name',
  DealPriorityOverride: 'Deal Priority Override',
  Deals: 'Deals',
  DealsToBiddersAssociation: 'Deals to Bidders Association',
  DealsToChannelGroupsAssociation: 'Deals to Channel Groups Association',
  DealsToChannelsAssociation: 'Deals to Channels Association',
  DealsToContextualSegmentsAssociation: 'Deals to Contextual Segments Association',
  DealTier: 'Deal Tier',
  DealType: 'Deal Type',
  DealTypes: 'Deal Types',
  DebugPrebidDataWithAsterisk: 'Debug (Prebid Data)*',
  Default: 'Default',
  DefaultBaseFloor: 'Fallback Bid Floor',
  DefaultBaseFloorTooltip: 'Set the Fallback bid floor for this channel.',
  DefaultBaseFloorWarning: 'Fallback bid floor will be used if the bid floor is not set.',
  Delete: 'Delete',
  DeleteItem: 'Delete {{item}}',
  DeletingItem: 'Deleting {{item}}...',
  DeliveredImpressions: 'Delivered Impressions',
  DeliveredToDate: 'Delivered To Date',
  Delivering: 'Delivering',
  Delivery: 'Delivery',
  DeliveryControls: 'Delivery Controls',
  DeliveryGoalMet: 'Delivery Goal Met',
  Demand: 'Demand',
  DemandSource: 'Demand Source',
  DemandSources: 'Demand Sources',
  DemandSourceSettings: 'Demand Source Settings',
  Denied: 'Denied',
  Descending: 'Descending',
  Description: 'Description',
  Destinations: 'Destinations',
  Device: 'Device',
  DeviceEnvironment: 'Device Environment',
  DeviceEnvironments: 'Device Environments',
  DeviceModel: 'Device Model',
  DeviceModels: 'Device Models',
  Devices: 'Devices',
  DeviceTypes: 'Device Types',
  Dimension: 'Dimension',
  Dimensions: 'Dimensions',
  Disable: 'Disable',
  DisableAddLineItemTooltip: 'Must save order before adding line items.',
  Disabled: 'Disabled',
  DisableDeleteOrderTooltip: 'Cannot delete order with line items.',
  DisabledWhileInTesting: 'Disabled while in testing.',
  DisableSamplingWithAsterisk: 'Disable Sampling *',
  Distributor: 'Distributor',
  DistributorName: 'Distributor Name',
  DMA: 'DMA',
  DMACode: 'DMA Code',
  DMAs: 'DMAs',
  DontPassID: `Don't Pass ID`,
  DOOHBidder: 'DOOH Bidder',
  DOOHDeviceTypeRewrite: 'DOOH Device Type Rewrite',
  Download: 'Download',
  DownloadComplete: 'Download Complete',
  DownloadCSV: 'Download CSV',
  DownloadFailed: 'Download Failed',
  Draft: 'Draft',
  Drill: 'Drill',
  DSPPartner: 'DSP Partner',
  DuplicateItem: 'Duplicate {{item}}',
  Duration: 'Duration',
  Dynamic: 'Dynamic',
  eCPM: 'eCPM',
  Edit: 'Edit',
  EditingGroup: 'Editing Group',
  EditItem: 'Edit {{item}}',
  EleaAIEnrichment: 'Enrichment',
  Email: 'Email',
  EmailAddress: 'Email Address',
  EmailAddresses: 'Email Addresses',
  EMEA: 'EMEA',
  EmptyString: 'Empty String',
  EmptyWithParentheses: '(empty)',
  Enable: 'Enable',
  Enabled: 'Enabled',
  EnableForAllInventoryWithColon: 'Enable for All Inventory:',
  EnableFraudDetectionAcrossAllOfYourInventory: 'Enable Fraud Detection across all of your inventory',
  EnableFraudDetectionPerBidder: 'Enable Fraud Detection per bidder',
  EnableInventorySmartFloorsWithAsterisk: 'Enable Inventory Smart Floors *',
  EnableItem: 'Enable {{item}}',
  EnableMRMDataEnrichmentDecisioning: 'Enable MRM Decisioning',
  EnableMRMDataEnrichmentLabeling: 'Enable MRM Labeling',
  EnableMRMDataEnrichmentWithAsterisk: 'Enable MRM Data Enrichment *',
  EnableOptableEIDs: 'Enable Optable EIDs',
  EnablePremiumAdQualityToolsAccess: 'Enable Premium Ad Quality Tools Access',
  End: 'End',
  EndDate: 'End Date',
  EndDateRange: 'End Date Range',
  Endpoint: 'Endpoint',
  EndpointDealID: 'Endpoint Deal ID',
  EndpointDomain: 'EndpointDomain',
  EndpointIDKey: 'Endpoint ID (Key)',
  EndpointPrefix: 'Endpoint Prefix',
  EndpointReqL24H: 'Endpoint Req. (L24H)',
  EndpointReqL7D: 'Endpoint Req. (L7D)',
  EndpointRequest: 'Endpoint Request',
  EndpointRequests: 'Endpoint Requests',
  EndpointRoute: 'Endpoint Route',
  EndpointSubdomain: 'Endpoint Subdomain',
  EndTime: 'End Time',
  EnforceMatchingDealIDInBidResponse: 'Enforce matching DealID in Bid Response',
  EnforceSlotTargeting: 'Enforce Slot Targeting',
  English: 'English',
  EnsureSlightOverDelivery: 'Ensure Slight Over-Delivery',
  EnsureSlightOverDeliveryTooltip: 'If activated, {{item}} is set to marginally surpass 100% delivery to fully achieve the impressions goal.',
  EnteringViewportSoundOff: 'Entering viewport sound off',
  EnteringViewportSoundOn: 'Entering viewport sound on',
  EnterItemOrUploadCSV: 'Enter {{item}} or upload a CSV',
  EnterLimit: 'Enter Limit',
  Error: 'Error',
  ErrorBidAdjustmentCannotBeMoreThan200Percent: 'Bid Adjustment cannot be more than 200%.',
  ErrorBidAdjustmentValueCannotBeNegative: 'Bid Adjustment Value cannot be negative.',
  ErrorBidderParamsTotalCannotExceed65535Characters: 'Bidder params total cannot exceed 65,535 characters.',
  ErrorBidFloorMustBe0OrHigher: 'Bid Floor must be $0 or higher (Leave empty if $0).',
  ErrorCannotIncludeAndExcludeTheSameLocalTargetForItemWithReasons: 'Cannot both include and exclude the same local target for {{item}}: {{text}}.',
  ErrorCannotUseVarABecauseNotSelectedInMetricADropdown: 'Cannot use var "a" because it has not been selected in Metric A dropdown.',
  ErrorCannotUseVarBBecauseNotSelectedInMetricBDropdown: 'Cannot use var "b" because it has not been selected in Metric B dropdown.',
  ErrorChooseCustomName: 'Choose a custom name.',
  ErrorDailyRequestCapMustBeGreaterOrEqual10k: 'Daily Request Cap must be greater or equal 10k.',
  ErrorDailyRequestCapMustBeValidPositiveInteger: 'Daily Request Cap must be a valid, positive integer.',
  ErrorDuplicateEventTrackersInCSVFileWithReasons: 'Duplicate event trackers for mediafiles in CSV file: {{text}}.',
  ErrorDuplicateMediafilesInCSVFileWithReasons: 'Duplicate domain names for mediafiles in CSV file: {{text}}.',
  ErrorDuplicateValueForLocalPanelForItemWithReasons: 'Duplicate value for Local Panel {{item}}: {{text}}.',
  ErrorEmptyItem: 'Empty {{item}}',
  ErrorEndDateMustBeAfterStartDate: 'End Date must be after Start Date.',
  ErrorEndTimeMustBeAfterStartTime: 'End Time must be after Start Time.',
  ErrorFailedToAddItemToIABCatBlocklist: 'Failed to add {{item}} to IABCatBlocklist; already in.',
  ErrorGenericSystemFailure: "An error occurred. Please try again. If the issue persists, notify your account manager and we'll look into it promptly.",
  ErrorIndexMustBe1: 'Index must be 1.',
  ErrorInvalidEventTrackersInCSVFileWithReasons: 'Invalid event trackers for mediafiles in CSV file: {{text}}.',
  ErrorInvalidItem: 'Invalid {{item}}',
  ErrorInvalidItemWithReasons: 'Invalid {{item}}: {{text}}',
  ErrorInvalidMediafilesInCSVFileWithReasons: 'Invalid domain names for mediafiles in CSV file: {{text}}.',
  ErrorInvalidNotification: 'Invalid notification.',
  ErrorInvalidSlackWebhook: 'Invalid Slack webhook domain. Must use https://hooks.slack.com',
  ErrorItemCannotBeEmpty: '{{item}} cannot be empty.',
  ErrorItemIsRequired: '{{item}} is required.',
  ErrorItemMustBeBetweenNumAndAltNum: '{{item}} needs to be between {{number}} and {{altNumber}}.',
  ErrorItemMustBeValidNumber: '{{item}} must be a valid number.',
  ErrorItemMustHaveValueGreaterThanOrEqualToNum: '{{item}} must have a value greater than or equal to {{number}}.',
  ErrorItemNameCannotIncludeCommas: '{{item}} name cannot include commas.',
  ErrorItemNameCannotIncludeQuotes: '{{item}} name cannot include quotes.',
  ErrorItemNameCannotIncludeSlashes: '{{item}} name cannot include slashes.',
  ErrorItemNameMustBeLessThanNumberCharacters: '{{item}} name must be less than {{number}} characters long.',
  ErrorKeyMustStartWithAPS: 'Key must start with "aps".',
  ErrorLoadingData: 'Error Loading Data',
  ErrorLoadingItem: 'Error Loading {{item}}',
  ErrorMalformedInputDetectedInFields: 'Malformed input detected in fields: {{item}}.',
  ErrorMasquerade: "Failed to masquerade",
  ErrorMaximumDecimalsForShareOfVoiceIs4: 'The maximum decimals for Share of Voice is 4.',
  ErrorMinDurationCannotExceedMaxDuration: 'Min Ad Duration cannot exceed Max Ad Duration.',
  ErrorNoRecipientsSelected: 'No recipients selected.',
  ErrorOnlyCSVFilesAreSupported: 'Only CSV files are supported.',
  ErrorPleaseChoosePriceRange: 'Please choose a price range.',
  ErrorPleaseEnterAFixedPrice: 'Please enter a fixed price.',
  ErrorPleaseEnterAFixedPriceGreaterThan0: 'Please enter a fixed price greater than 0.',
  ErrorPleaseEnterCustomMetricFormula: 'Please enter a Custom Metric Formula.',
  ErrorPleaseEnterValidFormulaBeforeSavingCustomMetric: 'Please enter a valid formula before saving Custom Metric: {{item}}.',
  ErrorPleaseInputNumberGreaterThanOrEqualToNumber: 'Please input a number >= {{number}}.',
  ErrorPleaseInputPositiveNumber: 'Please input a positive number.',
  ErrorPleaseInputUniqueItemName: 'Please input a unique {{item}} name.',
  ErrorPleaseInputValidDecimal: 'Please input a valid decimal.',
  ErrorPleaseInputValidIntegerNotDecimal: 'Please input a valid integer, not a decimal.',
  ErrorPleaseInputValidNumber: 'Please input a valid number.',
  ErrorPleaseInputValidPrice: 'Please input a valid price.',
  ErrorPleaseInputValidRegionName: 'Please input a valid region name.',
  ErrorPleaseOnlyUseOnePeriodForFixedPrice: 'Please only use one . for fixed price.',
  ErrorPleaseProvideINVValue: 'Please provide an "inv" value.',
  ErrorPleaseProvideKey: 'Please provide a key.',
  ErrorPleaseProvideValue: 'Please provide a value.',
  ErrorPleaseProvideValueForItem: 'Please provide a value for {{item}}.',
  ErrorPleaseResolveAllErrors: 'Please resolve all errors before continuing.',
  ErrorPleaseSelectBiddersManageFraudDetection: 'Please select at least one header bidder to enable the blocklist.',
  ErrorPleaseSelectMetricAMetricBIsOptional: 'Please select a Metric A Value from the dropdown (Metric A is required, Metric B is optional).',
  ErrorPleaseUsePeriodAsDecimal: 'Please use . instead of , for decimal.',
  ErrorPodDurationAndSlotCountMutuallyExclusive: 'Only one of Pod Duration or Slot Count may be set.',
  ErrorPodDurationOrSlotCountRequired: 'Either Pod Duration or Slot Count must be greater than 0.',
  ErrorPriceMustBeNumber: 'Price must be a number.',
  ErrorPriceMustBePositiveNumber: 'Price must be a positive number.',
  ErrorSiteIdDMustBeAnInteger: 'Site ID must be an integer.',
  ErrorSiteIDMacroIsNotAllowedForOtherVASTTagBidders: 'The [SITE_ID] macro is not allowed for Other Vast Tag bidders targeting a {{item}} endpoint.',
  ErrorSmartFloorsAreUpdatingPleaseTrySavingAgain: 'Smart floors are updating. Please try saving again.',
  ErrorSorryNoPermissionForSection: `Sorry, you don't have the permission for this section.`,
  ErrorStartDateMustBeBeforeEndDate: 'Start Date must be before End Date.',
  ErrorStartTimeMustBeBeforeEndTime: 'Start Time must be before End Time.',
  ErrorThisNameIsAKnownDemandSourceType: 'This name is a known demand source type. Please enter another one.',
  ErrorTimeRangesCannotOverlap: 'Schedule Conflict: This period overlaps with an existing rule for the same key and value.',
  ErrorValidatingItemPleaseTryAgain: 'Error validating {{item}}. Please try again.',
  ErrorZIPCodeMustBeAtLeastThreeDigits: 'Zip code length must be at least 3 digits',
  ErrorZIPCodeMustBeNumeric: 'Zip code must be numeric',
  EventTracker: 'Event Tracker',
  EventTrackers: 'Event Trackers',
  ExactMatch: 'Exact Match',
  ExampleTextMatchesAltText: 'ex: {{text}} matches with {{altText}}',
  Exception: 'Exception',
  Exceptions: 'Exceptions',
  ExchangeRate: 'Exchange Rate',
  ExchangeTag: 'Exchange Tag',
  Exclude: 'Exclude',
  ExcludeHeaderbidders: 'Exclude Headerbidders',
  ExcludeHeaderbiddersTooltip: 'Exclude header bidders from the chart.',
  ExcludeToday: 'Exclude Today',
  Existing: 'Existing',
  ExpandAll: 'Expand All',
  ExtendedIDs: 'Extended IDs',
  ExtendedIDSettingPass: 'ExtendedIDSettingPass',
  ExtensionKeyValueParameters: 'Extension Key Value Parameters',
  ExternalConfigurations: 'External Configurations',
  ExternalDealID: 'External Deal ID',
  FailedToLoadItem: 'Failed to load {{item}}.',
  FailedToValidateItem: 'Failed to validate {{item}}.',
  FallbackAuctionParticipation: 'Fallback Auction Participation',
  False: 'False',
  Feature: 'Feature',
  Features: 'Features',
  FieldsMarkedWithAsteriskAreRequired: 'Fields marked with <redAsterisk /> are required.',
  Filter: 'Filter',
  FilterByDataProvider: 'Filter by Data Provider',
  Filters: 'Filters',
  First: 'First',
  FirstAndLastPod: 'First and Last Pod',
  FirstBuyer: 'First Buyer',
  FirstOrLast: 'First Or Last',
  FirstPod: 'First Pod',
  FirstPriceValue1: 'First Price (value = 1)',
  Fixed: 'Fixed',
  FixedPrice: 'Fixed Price',
  FixedPriceValue3: 'Fixed price (value = 3)',
  FlexibleBidding: 'Flexible Bidding',
  FlexibleBiddingEnabled: 'Flexible Bidding Enabled',
  FlexibleBiddingThresholds: 'Flexible Bidding Thresholds',
  FlightDates: 'Flight Dates',
  FlightEndDate: 'Flight End Date',
  FlightingImpressionGoal: 'Flighting Impression Goal',
  FlightStartDate: 'Flight Start Date',
  Floor: 'Floor',
  FloorLimits: 'Floor Limits',
  FloorPrice: 'Floor Price',
  FMT: 'FMT',
  Forecast: 'Forecast',
  FormatLabelWithCount: '{{label}} ({{count}})',
  FormatLabelWithSelection: '{{label}}: {{selection}}',
  FormatNumItems: '{{count}} {{item}}',
  FormatSelection: '{{selection}}',
  FormatTextWithParentheses: '({{text}})',
  FormatType: 'Format Type',
  FreewheelSectionIDs: 'Freewheel Section IDs',
  French: 'French',
  Frequency: 'Frequency',
  FrequencyCapping: 'Frequency Capping',
  FrequencyDuration: 'Frequency Duration',
  FrequencyImpressionsLimit: 'Frequency Impressions Limit',
  FrequencyUnit: 'Frequency Unit',
  From: 'From',
  FWSectionIDs: 'FWSectionIDs',
  FXRateUpdatedEvery12Hours: '*FX rate updated every 12 hours',
  GDPR: 'GDPR',
  GDPRConsent: 'GDPR Consent',
  GDPRConsentValue: 'GDPR Consent Value',
  General: 'General',
  GeneralSettings: 'General Settings',
  GenieAssistant: 'Genie Assistant',
  Genre: 'Genre',
  Geo: 'Geo',
  Geos: 'Geos',
  German: 'German',
  GivnTargeting: 'Givn Targeting',
  Goal: 'Goal',
  GooglePair: 'Google Pair',
  GooglePairExtendedIDSetting: 'Google Pair Extended ID Setting',
  GooglePairID: 'Google Pair ID',
  GoToItem: 'Go To {{item}}',
  GroupBy: 'Group By',
  GroupedBidders: 'Grouped Bidders',
  Groups: 'Groups',
  HBsToSitesAssociation: 'HBs to Sites Association',
  HeaderBidders: 'Header Bidders',
  HeaderBidderSelectToExclude: 'Header Bidders to Exclude',
  HideInactive: 'Hide Inactive',
  HideItem: 'Hide {{item}}',
  HighestValueFirst: 'Highest value will show first',
  HonorChannelFloor: 'Honor Channel Floor',
  HumanVerification: 'Human Verification',
  Hybrid: 'Hybrid',
  IAB: 'IAB',
  IABCat: 'IAB Cat',
  IABCategories: 'IAB Categories',
  IABCategory: 'IAB Category',
  IABCode: 'IAB Code',
  IABPrefix: 'IAB Prefix',
  IABSubcategory: 'IAB Subcategory',
  IABSuffix: 'IAB Suffix',
  ID: 'ID',
  Immediately: 'Immediately',
  ImpL24H: 'Imp. (L24H)',
  ImpL7D: 'Imp. (L7D)',
  Impression: 'Impression',
  ImpressionGoal: 'Impression Goal',
  Impressions: 'Impressions',
  ImpressionsPerUserPer: 'Impressions Per User Per',
  ImpTrend: 'Imp. Trend',
  Inactive: 'Inactive',
  Include: 'Include',
  Increment: 'Increment',
  InheritFromDemandSource: 'Inherit from Demand Source',
  InlineVAST: 'Inline VAST',
  InSeconds: 'In seconds.',
  Insights: 'Insights',
  InsightsWithAsterisk: 'Insights*',
  InternalServerError: 'Internal Server Error',
  InvalidBids: 'Invalid Bids',
  InvalidCreatives: 'Invalid Creatives',
  InvalidMediaFile: 'Invalid Mediafile',
  Inventory: 'Inventory',
  InventoryForecast: 'Inventory Forecast',
  InventoryGroupID: 'Inventory Group ID',
  InventoryPartnerDomain: 'Inventory Partner Domain',
  InventoryPartnerDomainOverride: 'Inventory Partner Domain Override',
  InventoryPartnerDomainOverrideIfEmpty: 'Inventory Partner Domain Override If Empty',
  InventoryPartnerDomainWithAsterisk: 'Inventory Partner Domain *',
  InventoryRouteTargetingChangeExcludedTooltip: 'Excluded - Toggle to Include.',
  InventoryRouteTargetingChangeExcludeToIncludeDescription: 'This will change targeting of this field from Excluding to Including. Note: only one destination param can be excluded at a time.',
  InventoryRouteTargetingChangeIncludedTooltip: 'Included - Toggle to Exclude - only one destination param can be excluded.',
  InventoryRouteTargetingChangeIncludeToExcludeDescription: 'This will change targeting of this field from Including to Excluding. Note: only one destination param can be excluded at a time.',
  InventoryRule: 'Inventory Rule',
  InventoryRuleDetails: 'Inventory Rule Details',
  InventoryRuleOptions: 'Inventory Rule Options',
  InventoryRules: 'Inventory Rules',
  InventoryRulesV1WithAsterisk: 'Inventory Rules v1 *',
  InventoryRulesV2WithAsterisk: 'Inventory Rules v2 *',
  InventoryType: 'Inventory Type',
  Investigation: 'Investigation',
  IPFilter: 'IP Filter',
  IPFilters: 'IP Filters',
  IPFiltersWithAsterisk: 'IP Filters *',
  IPFilterWithAsterisk: 'IP Filter *',
  IrisSignal: 'Iris Signal',
  IRISSignal: 'IRIS Signal',
  Italian: 'Italian',
  ItemColonNumber: '{{item}}: {{number}}',
  ItemID: '{{item}} ID',
  ItemIfEmpty: '{{item}} If Empty',
  ItemIsInvalid: '{{item}} is invalid.',
  ItemIsRequired: '{{item}} is required and cannot be empty.',
  ItemManagement: '{{item}} Management',
  ItemName: '{{item}} Name',
  ItemNumber: '{{item}} {{number}}',
  ItemSettings: '{{item}} Settings',
  ItemTargeted: '{{item}} Targeted',
  ItemToApplyOnCommaSeparated: '{{item}} to apply on, can be comma separated',
  Japanese: 'Japanese',
  Key: 'Key',
  KeyLatenciesMS: 'Key Latencies (ms)',
  KeyValueParameters: 'Key Value Parameters',
  Keywords: 'Keywords',
  Korean: 'Korean',
  L12HEstimatedUplift: 'L12H Estimated Uplift',
  Language: 'Language',
  Last: 'Last',
  Last12H: 'Last 12H',
  Last14Days: 'Last 14 Days',
  Last15Days: 'Last 15 Days',
  Last30Days: 'Last 30 Days',
  Last31Days: 'Last 31 Days',
  Last3Days: 'Last 3 Days',
  Last7Days: 'Last 7 Days',
  LastCreated: 'Last Created',
  LastModified: 'Last Modified',
  LastPod: 'Last Pod',
  LastUpdated: 'Last Updated',
  LastUpdatedAtTimestamp: 'Last Updated At {{timestamp}}',
  LATAM: 'LATAM',
  LatestHourOfDataAvailable: 'Latest hour of data available:',
  LaunchTest: 'Launch Test',
  Length: 'Length',
  LimitedAdTracking: 'Limited Ad Tracking',
  LineItem: 'Line Item',
  LineItems: 'Line Items',
  LineItemStatus: 'Line Item Status',
  LineItemsTotal: 'Line Items Total',
  LineItemTargeting: 'Line Item Targeting',
  Lines: 'Lines',
  LineUpdates: 'Line Updates',
  LinkCopied: 'Link Copied',
  Live: 'Live',
  LiveData: 'Live Data',
  LiveLogs: 'Live Logs',
  Liveramp: 'Liveramp',
  LiveRampATS: 'LiveRamp ATS',
  LiverampExtendedIDSetting: 'Liveramp Extended ID Setting',
  Livestreams: 'Livestreams',
  Loading: 'Loading',
  LoadingData: 'Loading Data...',
  LoadingEllipsis: 'Loading...',
  LoadingItemSettings: 'Loading {{item}} settings...',
  LoadingQuery: 'Loading Query...',
  LocalTarget: 'Local Target',
  LocalTargeting: 'Local Targeting',
  LocalTargetingAllowed: 'Local Targeting Allowed',
  LocalTargetingDescription: 'Combine any layer of geo targeting to granularly define the location. When using multiple locations, the logic applied between them will be OR. This means users in any of the defined locations will be targeted.',
  LocalTargetingExcluded: 'Local Targeting Excluded',
  LocalTargetingIncluded: 'Local Targeting Included',
  LocalTargetingLogic: 'Local Targeting Logic',
  LocalTargetingTooltipLogicAndWithText: 'Requests will reach this {{text}} only if all of the defined locations match',
  LocalTargetingTooltipLogicOrWithText: 'Requests will reach this {{text}} if any of the defined locations match',
  LocalTargets: 'Local Targets',
  LocalTargetTypes: 'Local Target Types',
  Location: 'Location',
  Logic: 'Logic',
  LookupFields: 'Lookup Fields',
  LowestValueFirst: 'Lowest value will show first.',
  ManagedPlatformConnectionsPublisher: 'Managed Platform Connections Publisher',
  ManagedPlatformConnectionsPublishers: 'Managed Platform Connections Publishers',
  ManageFraudBlocking: 'Manage fraud blocking for each bidder. Select the bidders from the dropdown to apply fraud detection.',
  ManageFraudDetection: 'Manage Fraud Detection',
  ManageThirdPartyAccounts: 'Manage Third Party Accounts',
  Mappings: 'Mappings',
  MarkAsAvailable: 'Mark as Available',
  MarkAsBooked: 'Mark as Booked',
  MatchDealID: 'Match Deal ID',
  Max: 'Max',
  MaxAdDuration: 'Max Ad Duration',
  MaxAdDurationOverride: 'Max Ad Duration Override',
  MaxBidFloor: 'Max Bid Floor',
  MaxKeyLengthIs: 'Max key length is',
  MaxTier: 'Max Tier',
  MaxValue: 'Max Value',
  MaxValueLengthIs: 'Max value length is',
  Measurement: 'Measurement',
  Mediafile: 'Mediafile',
  MediafileDomain: 'Mediafile domain',
  Member: 'Member',
  MENA: 'MENA',
  MessageTargetingFieldFromExcludingToIncluding: 'This will change targeting of this field from Excluding to Including.',
  MessageTargetingFieldFromIncludingToExcluding: 'This will change targeting of this field from Including to Excluding.',
  Metric: 'Metric',
  Metrics: 'Metrics',
  Midroll: 'Midroll',
  MimeTypes: 'Mime Types',
  Min: 'Min',
  MinAdDuration: 'Min Ad Duration',
  MinAdDurationOverride: 'Min Ad Duration Override',
  MinBidFloor: 'Min Bid Floor',
  MinimumCPMPerSecond: 'Minimum CPM Per Second',
  MinValue: 'Min Value',
  Miscellaneous: 'Miscellaneous',
  MissingPermission: 'Missing Permission',
  ModalConfirmationUpdateItemText: 'Please confirm that you want to update {{item}}.',
  ModalDeletedItemIDName: 'Deleted {{item}}: [{{id}}] {{name}}.',
  ModalFailedToDeleteItemIDName: 'Failed to delete {{item}}: [{{id}}] {{name}}.',
  ModalShouldItemBeRemoved: 'Should {{item}} be removed?',
  ModalYesDeleteItem: 'Yes, delete {{item}}.',
  Monitors: 'Monitors',
  Monthly: 'Monthly',
  MoreInfo: 'More info',
  MouseOverSoundOn: 'Mouse over sound on',
  MultiBid: 'Multi Bid',
  Name: 'Name',
  NameAZ: 'Name A-Z',
  NetCPM: 'Net CPM',
  Network: 'Network',
  Networks: 'Networks',
  New: 'New',
  NewItem: 'New {{item}}',
  NewItemName: 'New {{item}} Name',
  NoBids: 'No Bids',
  NoCityAvailable: 'No city available for selection',
  NoDataFound: 'No data found.',
  NoDataToDisplay: 'No data to display',
  NoImpressions: 'No Impressions',
  NoItemFound: 'No {{item}} Found',
  NoItemSelected: 'No {{item}} Selected',
  NoMax: 'No Max',
  None: 'None',
  NonOptOut: 'Non Opt Out',
  NoResultsFound: 'No results found.',
  NorthAmerica: 'North America',
  NotApplicable: 'N/A',
  NoticeSelectAtLeastOneChannelOrChannelGroup: 'Select at least one channel or channel group.',
  NotIncludedInForecast: 'Not included in forecast',
  NotLowPacing: 'Not Low Pacing',
  NotRunning: 'Not Running',
  NotScheduled: 'Not Scheduled',
  NotStartedYet: 'Not Started Yet',
  NumDeliveredToDate: '{{count}} delivered to date.',
  NumItemsSelected: '{{count}} {{item}} Selected',
  NumRows: '{{count}} Rows',
  NumSelected: '{{count}} Selected',
  OneHourFromNow: 'One Hour From Now',
  OneItemSelected: '1 {{item}} Selected',
  OpenAuctionBuyer: 'Open Auction Buyer',
  OpenAuctionBuyers: 'Open Auction Buyers',
  OpenItem: 'Open {{item}}',
  OpenMarket: 'Open Market',
  OptimizationInsights: 'Optimization Insights',
  OptimizedFloor: 'Optimized Floor',
  OptIn: 'Opt In',
  Option: 'Option',
  Options: 'Options',
  OptOut: 'Opt Out',
  Or: 'Or',
  Order: 'Order',
  OrderBy: 'Order By',
  OrderID: 'Order ID',
  Orders: 'Orders',
  OrderUpdates: 'Order Updates',
  OriginalBidResponse: 'Original Bid Response',
  OriginalDIDs: 'Original DIDs',
  OriginalVAST: 'Original VAST',
  ORTB: 'ORTB',
  ORTBObjects: 'ORTB Objects',
  ORTBType: 'oRTB Type',
  OutboundDeals: 'Outbound Deals',
  OutOfRangeDays: 'Out of range days',
  OverallImpressionLimit: 'Overall Impression Limit',
  Overview: 'Overview',
  PacedRequests: 'Paced Requests',
  Pacing: 'Pacing',
  PacingApproved: 'Pacing Approved',
  PacingRejected: 'Pacing Rejected',
  PageLoadSoundOff: 'Page load sound off',
  PageLoadSoundOn: 'Page load sound on',
  Parameter: 'Parameter',
  Parameters: 'Parameters',
  Partner: 'Partner',
  PassID: 'Pass ID',
  Payout: 'Payout',
  Percentage: 'Percentage',
  PercentL12HFloor: '% L12H Floor',
  PercentL12HUplift: '% L12H Uplift',
  Performances: 'Performances',
  Period: 'Period',
  PeriodRange: 'Period Range',
  Permission: 'Permission',
  PermissionWithAsterisk: 'Permission *',
  PersonalitySearchLabel: 'Search and select',
  PG: 'PG',
  PlaceholderEnterContentItemToBeBidOnHereCommaSeparated: 'Enter Content {{item}} to be bid on here, comma separated.',
  PlaceholderEnterContentItemToBidOn: 'Enter Content {{item}} to bid on, comma separated.',
  PlaceholderEnterCustomItemHereCommaSeparated: 'Enter Custom {{item}} here. Can be comma separated.',
  PlaceholderEnterCustomItemName: 'Enter a custom {{item}} name.',
  PlaceholderEnterItem: 'Enter {{item}}.',
  PlaceholderEnterItemCommaSeparatedHere: 'Enter {{item}} here, comma separated.',
  PlaceholderSearchAndSelectPersonalities: 'Search and select personalities',
  Placement: 'Placement',
  PlatformConnect: 'Platform Connect',
  PlaybackMethod: 'Playback Method',
  PlaybackMethods: 'Playbook Methods',
  PlusAdd: '+ Add',
  PlusAddItem: '+ Add {{item}}',
  PlusCreateItem: '+ Create {{item}}',
  PlusItem: '+ {{item}}',
  PMP: 'PMP',
  PoddedRequest: 'Podded Request',
  PoddedRequestType: 'Podded Request Type',
  PodDuration: 'Pod Duration',
  PodDurations: 'Pod Durations',
  PodDurationSeconds: 'Pod Duration (sec)',
  PodSequence: 'Pod Sequence',
  Portuguese: 'Portuguese',
  Position: 'Position',
  PostBidAdvertiserReportingDoubleVerify: 'Post Bid Advertiser Reporting (DoubleVerify)',
  PostBidAdvertiserReportingIAS: 'Post Bid Advertiser Reporting (IAS)',
  Postroll: 'Postroll',
  Prefix: 'Prefix',
  PremiumFeatures: 'Premium Features',
  PrePostRoll: 'Pre/Post Roll',
  Preroll: 'Preroll',
  Preset: 'Preset',
  PresetAssociations: 'Preset Associations',
  Presets: 'Presets',
  Preview: 'Preview',
  PreviousPeriod: 'Previous Period',
  PreviousTest: 'Previous Test',
  PreviousTests: 'Previous Tests',
  Price: 'Price',
  PriceRange: 'Price Range',
  Prices: 'Prices',
  Priority: 'Priority',
  Privacy: 'Privacy',
  Prodqual: 'Prodqual',
  Producer: 'Producer',
  ProducerID: 'Producer ID',
  ProducerName: 'Producer Name',
  Profile: 'Profile',
  PublicaDealID: 'Publica Deal ID',
  Publisher: 'Publisher',
  PublisherID: 'Publisher ID',
  PublisherName: 'Publisher Name',
  PublisherNames: 'Publisher Names',
  Publishers: 'Publishers',
  PublisherSeat: 'Publisher Seat',
  PublisherSetting: 'Publisher Setting',
  Range: 'Range',
  Rate: 'Rate',
  Rating: 'Rating',
  RawRequests: 'Raw Requests',
  ReadOnly: 'Read-Only',
  ReadOnlyTooltipText: 'This item is read-only and cannot be edited.',
  Ready: 'Ready',
  RealTimeToggleText: 'Real-Time (L24 hrs)',
  RealTimeToggleTooltipText: 'Real-time insights are available for the last 24 hours.',
  Recipient: 'Recipient',
  Recipients: 'Recipients',
  Refresh: 'Refresh',
  RefreshChanges: 'Refresh Changes',
  Region: 'Region',
  RegionName: 'Region Name',
  Regions: 'Regions',
  Remove: 'Remove',
  RemoveContentItem: 'Remove Content {{item}}',
  RemoveContentItemFromRequest: 'Remove Content {{item}} from request.',
  RemoveEntireContentObjectFromBidRequest: 'Remove entire content object from bid request.',
  RemoveFMTJSON: 'Remove FMT JSON',
  RemoveGPPFromBidRequest: 'Remove GPP From Bid Request',
  RemoveItem: 'Remove {{item}}.',
  RemoveItemFromRequest: 'Remove {{item}} from request.',
  RepeatingOn: 'Repeating On',
  Report: 'Report',
  Reporting: 'Reporting',
  Reports: 'Reports',
  ReportType: 'Report Type',
  ReportTypes: 'Report Types',
  RequestedPodDurationSeconds: 'Requested Pod Duration (seconds)',
  RequiredDuration: 'Required Duration',
  reseller_evrideo: 'EVrideo',
  reseller_orka: 'Orka',
  reseller_ottera: 'Ottera',
  reseller_publica: 'Publica',
  Resellers: 'Resellers',
  Reset: 'Reset',
  ResponsesBlocked : 'Responses Blocked',
  ResponseType: 'Response Type',
  Restrict: 'Restrict',
  RestrictedToSuperAdmin: 'Restricted To Super Admin',
  Revenue: 'Revenue',
  Revert: 'Revert',
  ReviewEditedFields: 'Review edited fields',
  RevL24H: 'Rev. (L24H)',
  RevL7D: 'Rev. (L7D)',
  RevTrend: 'Rev. Trend',
  Rewrites: 'Rewrites',
  Routes: 'Routes',
  Rows: 'Rows',
  RuleDetails: 'Rule Details',
  RuleID: 'Rule ID',
  RuleName: 'Rule Name',
  Rules: 'Rules',
  RuleTypeSettings: 'Rule Type Settings',
  RunForecast: 'Run Forecast',
  Running: 'Running',
  Salesperson: 'Salesperson',
  SamplingDaysDisabled: 'Sampling Days Disabled',
  SamplingDisabledUntil: 'Sampling Disabled Until',
  SamplingPercentage: 'Sampling Percentage',
  SamsungEPGMetadata: 'Samsung EPG Metadata',
  SamsungIdentity: 'Samsung Identity',
  SankeyNotice: 'Click a node to zoom in and view the subsequent flow details. Reset to view the entire flow.',
  SankeyNoticeNoRealTime: 'Click a node to zoom in and view the subsequent flow details. Reset to view the entire flow. Note: today\'s data does not include real-time updates.',
  Save: 'Save',
  SaveAndEmail: 'Save and Email',
  SaveItem: 'Save {{item}}',
  SaveWithoutLaunching: 'Save Without Launching',
  SavingItem: 'Saving {{item}}...',
  Schedule: 'Schedule',
  Scheduled: 'Scheduled',
  ScheduledDay: 'Scheduled Day',
  Search: 'Search',
  SearchByDemandSource: 'Search By Demand Source',
  SearchByKeywordOrValue: 'Search by keyword or value.',
  SearchByName: 'Search By Name',
  SearchByNameID: 'Search By Name, ID',
  Season: 'Season',
  Seat: 'Seat',
  SecondaryRequests: 'Secondary Requests',
  SectionIDs: 'Section IDs',
  SeeItem: 'See {{item}}',
  SegmentAndOr: 'Segment And/Or',
  Segments: 'Segments',
  Select: 'Select',
  SelectAll: 'Select All',
  SelectAndAddIABCat: 'Select and add IAB category.',
  SelectContextualSegments: 'Select Contextual Segments',
  SelectCountriesToIncludeInRegion: 'Select countries to include in region',
  SelectDemandSource: 'Select Demand Source',
  Selected: 'Selected',
  SelectedAdBreakSchedule: 'Selected Ad Break Schedule',
  SelectedItem: 'Selected {{item}}',
  SelectedLineItems: 'Selected Line Items',
  SelectedOrders: 'Selected Orders',
  SelectErrorMustSelectOption: 'You must select an option to continue.',
  SelectItem: 'Select {{item}}',
  SelectLiveContextSuitabilitySegments: 'Select Live Context Suitability Segments',
  SelectOneOfTheFollowingFeaturesFraudTraffic: 'Select one of the following features to control how you block fraudulent traffic.',
  SelectUpToNumItems: 'Select Up To {{number}} {{item}}.',
  Series: 'Series',
  SetItem: 'Set {{item}}',
  SetLimitTo: 'Set Limit To',
  Settings: 'Settings',
  ShareAsLink: 'Share as link',
  SharedWithBackfill: 'Shared With Backfill',
  SharedWithNoBackfill: 'Shared With No Backfill',
  ShareOfVoice: 'Share of Voice',
  ShareOfVoiceType: 'Share Of Voice Type',
  ShowAll: 'Show All',
  ShowInactive: 'Show Inactive',
  Showing: 'Showing',
  ShowingActiveOnly: 'Showing Active Only',
  ShowingAll: 'Showing All',
  ShowingInactiveOnly: 'Showing Inactive Only',
  ShowingNumOfTotalResults: 'Showing {{number}} of {{total}} results.',
  ShowItem: 'Show {{item}}',
  ShowLess: 'Show Less',
  ShowMore: 'Show More',
  Site: 'Site',
  SiteDomain: 'Site Domain',
  SiteDomainOverride: 'Site Domain Override',
  SiteDomainOverrideIfEmpty: 'Site Domain Override If Empty',
  SiteDomainOverrideWithAsterisk: 'Site Domain Override *',
  SiteDomains: 'Site Domains',
  SiteID: 'Site ID',
  SitePage: 'Site Page',
  SitePages: 'Site Pages',
  Sites: 'Sites',
  SiteSection: 'Site Section',
  SiteWeightEnabled: 'Site Weight Enabled',
  SiteWithAsterisk: 'Site *',
  Skip: 'Skip',
  SkipAfter: 'Skip After',
  SkipMin: 'Skip Min',
  Slot: 'Slot',
  SlotCount: 'Slot Count',
  Slots: 'Slots',
  Smart: 'Smart',
  SmartFloorConfigs: 'Smart Floor Configs',
  SmartFloors: 'Smart Floors',
  SmartFloorsAssistant: 'Smart Floors Assistant',
  SmartFloorsAssistantAnalyzeControlVsSmart: 'Analyze control vs smart performance',
  SmartFloorsAssistantAnalyzeFloorDecisions: 'Analyze optimal floor decisions',
  SmartFloorsAssistantAskAQuestion: '* Ask a Question',
  SmartFloorsAssistantAskQuestion: 'Ask a question to get started',
  SmartFloorsAssistantError: 'Failed to get a response. Please try again.',
  SmartFloorsAssistantNoResults: 'No results found.',
  SmartFloorsAssistantPlaceholder: '* Ask a question...',
  SmartFloorsAssistantSend: 'Send',
  SmartFloorsAssistantThinking: 'Thinking',
  SmartFloorsAssistantTopContentChannels: 'Top Content Channels by Response CPM per Second',
  SmartFloorsAssistantTopDemandSources: 'Top Demand Sources by Response CPM',
  SmartFloorsAssistantTopPerformingContextByRevenue: 'Top performing context by revenue',
  Smooth: 'Smooth',
  SnackbarChangesSavedWithWarnings: 'Changes saved but some warnings exist.',
  SnackbarConnectionErrorPleaseTryAgain: 'Connection error. Please try again',
  SnackbarErrorDeletingItem: 'Error deleting {{item}}. Please refresh.',
  SnackbarErrorPleaseFixErrorsAndTryAgain: 'Please fix errors and try again.',
  SnackbarErrorRefreshingDataLastUpdatedAtTimestamp: 'Error refreshing data. Data was last successfully updated at {{timestamp}}.',
  SnackbarErrorRetrievingData: 'Error retrieving data. Please wait and try again.',
  SnackbarErrorRetrievingFilters: 'Error retrieving filters. Please wait and try again.',
  SnackbarErrorRetrievingItem: 'Error retrieving {{item}}. Please wait and try again.',
  SnackbarErrorUnauthorized: `You don't have permission to view this {{item}}.`,
  SnackbarFailedToCloneItem: 'Failed to clone {{item}}.',
  SnackbarFailedToCreateItem: 'Failed to create {{item}}.',
  SnackbarFailedToDeleteItem: 'Failed to delete {{item}}.',
  SnackbarFailedToLoadBidderConfiguration: 'Failed to load bidder configuration.',
  SnackbarFailedToParseDebugInfo: 'Failed to parse debug info.',
  SnackbarFailedToUpdateIDName: 'Failed to update [{{id}}] {{name}}.',
  SnackbarFailedToUpdateItem: 'Failed to update {{item}}.',
  SnackbarInvalidConfigurationDetected: 'Invalid configuration detected.',
  SnackbarItemAlreadyExistWithReasons: '{{item}} already exists: {{text}}',
  SnackbarItemCreatedSuccessfully: '{{item}} created successfully.',
  SnackbarItemIDDeletedSuccessfully: '{{item}} {{id}} deleted successfully.',
  SnackbarItemIDDeletionFailed: '{{item}} {{id}} deletion failed.',
  SnackbarItemSavedSuccessfully: '{{item}} saved successfully.',
  SnackbarItemSettingsSaved: '{{item}} settings saved.',
  SnackbarItemUpdatedSuccessfully: '{{item}} updated successfully.',
  SnackbarNoDataFound: 'No data found.',
  SnackBarNoLiveDataFound: 'No live data found.',
  SnackbarPleaseFixErrorsBeforeSavingItemWithReasons: 'Please fix errors before saving {{item}}: {{text}}',
  SnackbarSelectedItemDoesNotExist: 'Selected {{item}} does not exist.',
  SnackbarSuccessfullyCreatedItem: 'Successfully created {{item}}.',
  SnackbarSuccessfullyDeletedItem: 'Successfully deleted {{item}}.',
  SnackbarSuccessfullyDeletedNumItems: 'Successfully deleted {{count}} {{item}}.',
  SnackbarSuccessfullySavedItem: 'Successfully saved {{item}}.',
  SnackbarSuccessfullyUpdatedIDName: 'Successfully updated [{{id}}] {{name}}.',
  SnackbarSuccessfullyUpdatedItem: 'Successfully updated {{item}}.',
  SnackbarUnableToLoadItemData: 'Unable to load {{item}} data.',
  SnackbarUnableToSaveChangesAtThisTime: 'Unable to save changes at this time.',
  SnackbarValidationFailedPleaseCheckYourInputs: 'Validation failed. Please check your inputs.',
  SortBy: 'Sort By',
  SOVBackfill: 'SOV Backfill',
  SOVParallelAuctions: 'SOV Parallel Auctions',
  Spanish: 'Spanish',
  SplitShareByDuration: 'Split Share By Duration',
  SplitShareByPod: 'Split Share By Pod',
  SponsorshipMode: 'Sponsorship Mode',
  SSPParameters: 'SSP Parameters',
  Start: 'Start',
  StartDate: 'Start Date',
  StartDateRange: 'Start Date Range',
  StartDelayOverride: 'Start Delay Override',
  StartTime: 'Start Time',
  State: 'State',
  States: 'States',
  Status: 'Status',
  StoreURL: 'Store URL',
  Stream: 'Stream',
  StreamTypes: 'Stream Types',
  Structured: 'Structured',
  StructuredSlot: 'Structured Slot',
  SubjectName: 'Subject Name',
  Subtypes: 'Subtypes',
  Summary: 'Summary',
  SuperUserOnly: 'Super-User Only',
  Supply: 'Supply',
  SwitchActiveStatusModalConfirm: 'Yes, change status to {{item}}',
  SwitchActiveStatusModalDescription: 'Switching active status to {{item}} will {{selection}} all Line Items under this Order.',
  SwitchActiveStatusModalTitle: 'Switch Active Status on {{item}}?',
  SyntheticDIDs: 'Synthetic DIDs',
  Tag: 'Tag',
  TargetedAdBreaks: 'Targeted Ad Breaks',
  TargetedChannelGroups: 'Targeted Channel Groups',
  TargetedChannelLists: 'Targeted Channel Lists',
  TargetedChannels: 'Targeted Channels',
  TargetedCountries: 'Targeted Countries',
  TargetedCountriesAllowed: 'Targeted Countries Allowed',
  TargetedDeals: 'Targeted Deals',
  TargetedDeviceModels: 'Targeted Device Models',
  TargetedDeviceModelsAllowed: 'Targeted Device Models Allowed',
  TargetedDevices: 'Targeted Devices',
  TargetedDevicesAllowed: 'Targeted Devices Allowed',
  TargetedDeviceSubtypes: 'Targeted Device Subtypes',
  TargetedDeviceSubtypesAllowed: 'Targeted Device Subtypes Allowed',
  TargetedDeviceTypes: 'Targeted Device Types',
  TargetedDeviceTypesAllowed: 'Targeted Device Types Allowed',
  TargetedLineItems: 'Targeted Line Items',
  TargetedLivestream: 'Targeted Livestream',
  TargetedLivestreams: 'Targeted Livestreams',
  TargetedOrders: 'Targeted Orders',
  TargetedRegions: 'Targeted Regions',
  TargetedRegionsAllowed: 'Targeted Regions Allowed',
  TargetedRequests: 'Targeted Requests',
  TargetedSegments: 'Targeted Segments',
  TargetedSegmentsAllowed: 'Targeted Segments Allowed',
  TargetedSiteDomainAllowed: 'Targeted Site Domain Allowed',
  TargetedSitePagesAllowed: 'Targeted Site Pages Allowed',
  TargetFirstAdbreakInSessionWithAsterisk: 'Target First Adbreak In Session *',
  TargetIfMissing: 'Target If Missing',
  TargetIfPresent: 'Target If Present',
  Targeting: 'Targeting',
  TargetingChange: 'Targeting Change',
  TargetingChannelGroups: 'Targeting Channel Groups',
  TargetingChannels: 'Targeting Channels',
  TargetingDeviceIDType: 'Targeting Device ID Type',
  TargetingParameters: 'Targeting Parameters',
  TargetingPresets: 'Targeting Presets',
  TargetingStateTooltip: 'Select a single State if available to ensure city targeting accuracy',
  TestIncrement: 'Test Increment',
  TestingRange: 'Testing Range',
  Tests: 'Tests',
  Threshold: 'Threshold',
  Tier: 'Tier',
  TierNumber: 'Tier {{number}}',
  Time: 'Time',
  TimePeriod: 'Time Period',
  TimePeriods: 'Time Periods',
  TimeRange: 'Time Range',
  Timestamp: 'Timestamp',
  Timezone: 'Timezone',
  Timezones: 'Timezones',
  TimezoneSetting: 'Timezone Setting',
  TimezoneType: 'Timezone Type',
  Title: 'Title',
  TmaxOffset: 'Tmax Offset',
  To: 'To',
  Tools: 'Tools',
  TooltipAdQualityToolsDescriptionWarning: 'Turning this feature on will grant users access to premium features on the channel level. Disabling a premium feature for the publisher will also remove the feature from any channels on which it was configured.',
  TooltipAdQualityToolsManageFeatureAccess: 'Manage premium feature access for this publisher.',
  TooltipAuctionInsightsAuctionFlow: 'The Auction flow visualizes historical data and does not currently include real-time.',
  TooltipAuctionInsightsBidResponses:  'A single bid request can receive multiple bid responses, so percentages may add up to more than 100%.',
  TooltipAuctionInsightsBreakdown: 'This table breaks down results based on your active Dataset and Filters. Click any row to navigate to its dedicated page and view real-time performance data for that single entity.',
  TooltipAuctionInsightsMinDate: 'Data is available starting from March 1, 2024.',
  TooltipAvgCPML24H: 'Average CPM Last 24 Hours',
  TooltipAvgCPML7D: 'Average CPM Last 7 Days',
  TooltipBeta: 'This feature is in beta. Contact your account manager if you are interested in testing this feature.',
  TooltipContentItemToBidOn: 'Content {{item}} to bid on, can be comma separated.',
  TooltipCustomName: 'Custom name to display on the homepage.',
  TooltipCustomParamReseller: 'Checks for custom param set in your request to {{item}} endpoint and includes or excludes the bidder. Can be comma separated',
  TooltipEndpointReqL24H: 'Endpoint Requests Last 24 Hours',
  TooltipEndpointReqL7D: 'Endpoint Requests Last 7 Days',
  TooltipExcludedToggleToInclude: 'Excluded - Toggle to Include',
  TooltipExtendedIDTargetingTypeDisabled: 'Ignore eID status when bidding.',
  TooltipExtendedIDTargetingTypes: 'Control how you bid on inventory based on the presence of identifiers like Iris, Google Pair, UID, and others.',
  TooltipExtendedIDTargetingTypeTargetIfMissing: 'Target inventory that has no Extended IDs present.',
  TooltipExtendedIDTargetingTypeTargetIfPresent: 'Target inventory that contains any of the specified Extended IDs.',
  TooltipForecastIsTemporarilyUnavailable: 'Forecast is temporarily unavailable. Please check back soon.',
  TooltipImpL24H: 'Impressions Last 24 Hours',
  TooltipImpL7D: 'Impressions Last 7 Days',
  TooltipImpressionsTrend: 'Impressions Trend L7D Compared To Previous Period',
  TooltipIncludedToggleToExclude: 'Included - Toggle to Exclude',
  TooltipOpenItem: 'Open {{item}}.',
  TooltipPleaseSelectAtLeastOneFilterToContinue: 'Please select at least one filter to continue.',
  TooltipRevenueTrend: 'Revenue Trend L7D Compared To Previous Period',
  TooltipRevL24H: 'Revenue Last 24 Hours',
  TooltipRevL7D: 'Revenue Last 7 Days',
  TooltipUnavailableDueToSelectedFilters: 'Unavailable due to the selected filters.',
  TooltipUnavailableDueToSelectedPeriod: 'Unavailable due to the selected period.',
  TopAvgCPML24H: 'Top Average CPM',
  TopAvgCPML7D: 'Top Average CPM (L7D)',
  TopChannels: 'Top Channels',
  TopDemandSources: 'Top Demand Sources',
  TopEndpointReqsL24H: 'Top Endpoint Requests',
  TopEndpointReqsL7D: 'Top Endpoint Requests (L7D)',
  TopEndpointRequests: 'Top Endpoint Requests',
  TopImpressions: 'Top Impressions',
  TopImpressionsL24H: 'Top Impressions',
  TopImpressionsL7D: 'Top Impressions (L7D)',
  TopItemByAltItem: 'Top {{item}} by {{altItem}}',
  TopNum: 'Top {{number}}',
  TopRevenue: 'Top Revenue',
  TopRevenueL24H: 'Top Revenue',
  TopRevenueL7D: 'Top Revenue (L7D)',
  TotalImpressions: 'Total Impressions',
  Tracking: 'Tracking',
  Trafficker: 'Trafficker',
  Traffickers: 'Traffickers',
  Trends: 'Trends',
  True: 'True',
  Type: 'Type',
  UIBrandsDashboard: 'Brands Dashboard',
  UICreativeLibrary: 'Creative Library',
  UID20: 'UID 2.0',
  UID20ExtendedIDSetting: 'UID 2.0 Extended ID Setting',
  UIPlatformConnect: 'Platform Connect',
  UnableToSendEmail: 'Unable to send email.',
  Unit: 'Unit',
  Unknown: 'Unknown',
  UnknownItem: 'Unknown {{item}}',
  UnnamedAdBreak: 'Unnamed Ad Break',
  UnnamedContentMetadata: 'Unnamed Content Metadata',
  UnnamedCustomData: 'Unnamed Custom Data',
  UnnamedRule: 'Unnamed Rule',
  UnpaidBidder: 'Unpaid Bidder',
  Unscheduled: 'Unscheduled',
  Untargeted: 'Untargeted',
  UnwrapErrors: 'Unwrap Errors',
  UnwrappedVAST: 'Unwrapped VAST',
  Upcoming: 'Upcoming',
  UpdateItem: 'Update {{item}}',
  Updates: 'Updates',
  UploadCSV: 'Upload CSV',
  UploadCSVToSharedS3RoleTooltip: 'Please upload a CSV via your shared S3 role for the table to populate',
  UploadItem: 'Upload {{item}}',
  UploadNewItem: 'Upload New {{item}}',
  User: 'User',
  UserHaveNoPermission: "Sorry, you don't have the permission for this section",
  Users: 'Users',
  UserType: 'User Type',
  UseSupplyFloor: 'Use Supply Floor',
  UseVASTPriceExtension: 'Use VAST Price Extension',
  UUID: 'UUID',
  ValidBids: 'Valid Bids',
  ValidBidsRejected: 'Valid Bids Rejected',
  Value: 'Value',
  Values: 'Values',
  VAST: 'VAST',
  VASTPriceExtension: 'VAST Price Extension',
  VASTURL: 'VAST URL',
  VASTURLInfo: 'For supported macros, please refer to our wiki.',
  Venue: 'Venue',
  VenueID: 'Venue ID',
  Video: 'Video',
  ViewBy: 'View By',
  ViewCurrentItem: 'View Current {{item}}',
  Viewer: 'Viewer',
  VMAP: 'VMAP',
  VMAPResponseType: 'VMAP Response Type',
  WarningColonText: 'WARNING: {{text}}',
  WarningMessageReplaceSpringServeMacros: 'Replace SpringServe macros.',
  Webhook: 'Webhook',
  Weekly: 'Weekly',
  WithAPI: 'With API',
  YahooConnectID: 'Yahoo Connect ID',
  YAxisMetric: 'Y-axis metric',
  YesConfirmUpdates: 'Yes, confirm updates.',
  You: 'You',
  ZIP: 'ZIP',
  ZIPCode: 'ZIP Code',
  ZIPs: 'ZIPs',
  Zone: 'Zone',
};
